<div class="modal-backdrop">
    <div class="modal-container">
        <div class="modal-header">
            <div class="title-section">
                <h2>Assign New Goal(s)</h2>
                <p>Enable the goals & corresponding targets below that you would like to assign to this hospital. Press
                    the save button when complete.</p>
            </div>
            <button class="close-btn" (click)="onClose()">
                <span class="material-icons">close</span>
            </button>
        </div>
<mat-dialog-content>

        <div *ngIf="filteredGoals && filteredGoals.length > 0">

            <div class="search-bar">
                <input type="text" placeholder="Search Goals..." [(ngModel)]="searchQuery"
                    (ngModelChange)="onSearchChange($event)">
                <span class="material-icons search-icon">search</span>
            </div>

            <div class="goals-list" *ngIf="filteredGoals && filteredGoals.length > 0">

                <div class="goal-item" [ngClass]="{ 'checked': goal?.isRecommended }"
                    *ngFor="let goal of filteredGoals">
                    <div class="goal-header">
                        <label class="checkbox-label">
                            <input type="checkbox" [checked]="goal.isGoalTarget"
                                (change)="onGoalTargetChange($event,goal.goalId)" [disabled]="goal.isGoalTarget">
                            <span class="goal-name">{{goal.goalName}}</span>
                        </label>
                        <!-- <div class="goal-actions">
                        <span class="status-badge inactive">Inactive</span>
                        <span class="material-icons arrow-icon">chevron_right</span>
                    </div> -->
                    </div>

                    <div class="goal-info-accordion" *ngIf="hasGoalDetailContent(goal)">
                        <button type="button" class="goal-info-toggle"
                            [attr.aria-expanded]="expandedGoalId === goal.goalId"
                            (click)="toggleGoalDetails(goal.goalId, $event)">
                            <span class="goal-info-toggle-label">Goal Information</span>
                            <span class="material-icons goal-info-toggle-icon">
                                {{ expandedGoalId === goal.goalId ? 'expand_less' : 'expand_more' }}
                            </span>
                        </button>
                        <div class="goal-info-content" *ngIf="expandedGoalId === goal.goalId">
                            <div class="goal-info-row" *ngIf="goal.description">
                                <div class="goal-info-label">Goal Description</div>
                                <div class="goal-info-value">{{ goal.description }}</div>
                            </div>
                            <div class="goal-info-row" *ngIf="goal.explanation">
                                <div class="goal-info-label">Goal Explanation</div>
                                <div class="goal-info-value">{{ goal.explanation }}</div>
                            </div>
                            <div class="goal-info-row" *ngIf="goal.calcDisplay">
                                <div class="goal-info-label">How this Goal is Calculated</div>
                                <div class="goal-info-value">{{ goal.calcDisplay }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="goal-metrics">
                        <div class="metric">
                            <span class="label">BASELINE QUARTER</span><span class="value">{{ formatBaselineAsPercent(goal.avg) | formatValue: goal.recommendedType }}</span>
                        </div>
                        <div class="metric">
                            <span class="label">LAST QUARTER</span><span class="value">{{goal?.lastQuarter | formatValue: goal.recommendedType }}</span>
                        </div>
                        <div class="metric">
                            <span class="label">RECOMMENDED</span><span class="value">{{goal.recommended | formatValue: goal.recommendedType }}</span>
                        </div>
                        <div class="metric target">
                            <span class="label">TARGET</span>
                            <div class="target-input-group">
                                <input type="number" min="1" max="100" [(ngModel)]="goal.recommendedTarget"
                                    (keydown)="preventNegativeKey($event)"
                                    (ngModelChange)="onRecommendedTargetChange(goal)" class="target-input"
                                    [disabled]="goal.isGoalTarget">
                                <div class="target-type" *ngIf="goal.recommendedType">
                                    {{goal.recommendedType }}
                                </div>
                            </div>

                            <div class="target-error" *ngIf="goal.targetExceeded">Maximum allowed is 100. Value cleared.
                            </div>
                        </div>

                        <div class="metric recommendation-display" *ngIf="goal.recommendationReason">
                            <span class="label">RECOMMENDATION REASON</span>
                            <span class="value">{{ getRecommendationReasonDisplay(goal) }}</span>
                        </div>

                        <div class="metric target">
                            <span class="label">Is Recommended</span>
                            <div class="target-input-group">
                                <input type="checkbox" [(ngModel)]="goal.recommendedFlag" class="target-input"
                                    [disabled]="!canEditRecommended(goal)"
                                    (ngModelChange)="onRecommendedChange(goal.goalId, $event)">
                            </div>
                        </div>
                        <div class="metric target">
                            <span class="label">Show on HM Dashboard</span>
                            <label class="switch"
                                [attr.aria-label]="'Show ' + goal.goalName + ' on Hospital Manager Dashboard'">
                                <input type="checkbox" [(ngModel)]="goal.isHM" [disabled]="goal.isGoalTarget"
                                    (ngModelChange)="onHmToggleChange(goal.goalId, $event)">
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                    <div class="reasoning-block" *ngIf="isTargetDifferent(goal) && !goal.isGoalTarget">
                        <label class="reasoning-label">Reasoning <span class="required-star">*</span></label>
                        <textarea
                            class="reasoning-input"
                            [(ngModel)]="goal.reasoning"
                            rows="2"
                            placeholder="Please explain why the target differs from the recommended value..."
                            [disabled]="goal.isGoalTarget"
                        ></textarea>
                        <div class="reasoning-error" *ngIf="goal.reasoningRequired && !goal.reasoning?.trim()">
                            Reasoning is required when target differs from recommended.
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="filteredGoals && filteredGoals.length === 0">
            <div class="empty-state">
                <div class="empty-icon">
                    <span class="material-icons">assignment</span>
                </div>
                <h4>No Goal found</h4>
                <p>Try adjusting filters or create a new goal.</p>
            </div>
        </div>
</mat-dialog-content>

    <div class="modal-footer">
        <div class="action-buttons">
            <button class="cancel-btn" (click)="onClose()">Cancel</button>
            <button type="button" class="v-button v-button-md v-green" (click)="onSave()" [disabled]="loading">
                <ng-container *ngIf="!loading">Save <span class="material-icons"
                        style="font-size: 16px; margin-left: 5px; vertical-align: middle;">check</span></ng-container>
                <ng-container *ngIf="loading">
                    <i class="pi pi-spin pi-spinner mr-2"></i>
                    Saving...
                </ng-container>
            </button>
        </div>
    </div>
</div>
    <div *ngIf="isLoading" class="loading-overlay">
        <div style="text-align: center;">
            <img src="/assets/catSpinner.gif" style="width:130px; margin-bottom: 20px;">
            <div style="color:#363636; font-size: 24px;">Please wait...</div>
        </div>
    </div>
</div>
